import ReviewAllowedAuthorType from '@/enums/ReviewAllowedAuthorType';

const state = {
  sessionParams: {},
  isLoadingSession: false,
  currentUser: null
};

const getters = {
  isLoggedIn({ sessionParams }, _getters, { env }) {
    return env === 'development'
      ? !!sessionParams.username
      : !!sessionParams.secure_username;
  },
  isLoginRequired(_state, getters, { reviewSettings }) {
    return (
      !getters.isLoggedIn &&
      reviewSettings.reviewSettings.allowed_author_type !==
        ReviewAllowedAuthorType.EVERYONE
    );
  }
};

const mutations = {
  SET_SESSION_PARAMS(state, sessionParams) {
    state.sessionParams = sessionParams;
  },
  SET_CURRENT_USER(state, currentUser) {
    state.currentUser = currentUser;
  },
  SET_IS_LOADING_SESSION(state, isLoadingSession) {
    state.isLoadingSession = isLoadingSession;
  }
};

const actions = {
  fetchSession({ commit, rootState }) {
    commit('SET_IS_LOADING_SESSION', true);
    return rootState.api
      .fetchSession()
      .then(({ data }) => {
        commit('SET_CURRENT_USER', data.current_user);
      })
      .finally(() => {
        commit('SET_IS_LOADING_SESSION', false);
      });
  },
  setSessionParams({ commit, rootState: { env } }, params) {
    const keys = [
      'secure_device_token',
      ...(env === 'development'
        ? ['username', 'user_name']
        : ['secure_username', 'secure_user_name'])
    ];

    const sessionParams = keys
      .filter(k => !!params[k])
      .reduce((a, k) => ({ ...a, [k]: params[k] }), {});

    commit('SET_SESSION_PARAMS', sessionParams);
  }
};

export default { namespaced: true, state, getters, mutations, actions };
